import React from "react";
import { Modal } from "react-bootstrap";
import { ModalCloseIcon } from "../../constants/svg";

const rows = [
  { key: "unreadChats", label: "Unread chats" },
  { key: "surveysNotSubmitted", label: "Surveys not submitted" },
  { key: "quizzesFailed", label: "Quizzes failed" },
  { key: "eventsNoRsvp", label: "Events with no RSVP" },
  { key: "missedGoals", label: "Missed goals" },
  {
    key: "timeOffRequests",
    label: "Time off requests",
    note: "Does not change the score",
  },
  { key: "resourcesNotViewed", label: "Resources not viewed" },
  { key: "documentsNotViewed", label: "Documents not viewed" },
];

const HealthScoreModal = ({ member, onHide }) => {
  const score = member?.healthScore;

  return (
    <Modal
      show={Boolean(member && score)}
      onHide={onHide}
      centered
      className="health-score-modal"
    >
      <Modal.Header>
        <Modal.Title>{member?.employeeName}</Modal.Title>
        <button
          type="button"
          className="closeBtn"
          onClick={onHide}
          aria-label="Close"
        >
          <ModalCloseIcon />
        </button>
      </Modal.Header>
      {score ? (
        <Modal.Body>
          <div
            className={`health-score-total${score.needsAttention ? " is-low" : ""}`}
          >
            {score.score}%
          </div>
          <p className="health-score-note">Based on open items in the app.</p>
          <div className="health-score-list">
            {rows.map((row) => (
              <div className="health-score-row" key={row.key}>
                <div>
                  <span>{row.label}</span>
                  {row.note ? <small>{row.note}</small> : null}
                </div>
                <strong>{score[row.key] || 0}</strong>
              </div>
            ))}
          </div>
        </Modal.Body>
      ) : null}
    </Modal>
  );
};

export default HealthScoreModal;
